import React from 'react'

export const About = () => (
  <div className="jumbotron">
    <div className="container">
      <h1 className="display-4">
        Designed & developed by&nbsp;
        <strong>
          Tyooma
        </strong>
      </h1>
      <p className="lead">
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up

        <a href="https://github.com/tyooma" className="badge badge-light">
          &nbsp;My GitHub&nbsp;
        </a>

        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up

        <a href="https://www.linkedin.com/in/tyooma/" className="badge badge-light">
          &nbsp;My LinkedIn&nbsp;
        </a>

        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
        Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up Notes up
      </p>
    </div>
  </div>
)
